import React, { useEffect, useState } from 'react';
import logo from '../../assets/navbar/culturTap logo.svg';
import appStore from '../../assets/navbar/appStore.svg';
import playStore from '../../assets/navbar/playStore.svg';
import { Link, useLocation } from 'react-router-dom';
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import Genie from "../../assets/navbar/logo.svg";
import AppStoreModal from '../utils/AppStoreModal';

const Navbar = () => {
    const [currPage, setCurrPage] = useState("home");
    const [updatedURL, setUpdatedURL] = useState(window.location.href);
    const [isOpen, setisOpen] = useState(false);
    const [appStoreModal, setAppStoreModal] = useState(false);

    const location = useLocation();

    useEffect(() => {
        setUpdatedURL(location.pathname);
    }, [location]);

    useEffect(() => {
        if (updatedURL.includes('earn')) {
            setCurrPage("earn");
        } else if (updatedURL.includes('contact')) {
            setCurrPage("contact");
        } else {
            setCurrPage("home");
        }
    }, [updatedURL]);

    useEffect(() => {
        if (!updatedURL.includes('services') && !location.search.includes("termandcondition")) {
            window.scrollTo(0, 0);
        }
    }, [updatedURL, location.search]);

    const handleNav = () => {
        setisOpen(!isOpen);
    };

    return (
        <div className='w-screen bg-white shadow-sm z-50 fixed top-0 left-0 py-2'>
            {/* Desktop Layout */}
            <div className='hidden lg:flex items-center justify-between md:px-[14px] lg:pr-[50px] relative'>
                {/* Left: Logos - Fixed width */}
                <div className='flex items-center gap-4 pl-4 w-[300px]'>
                    <a href="/">
                        <img src={logo} alt="logo" loading='lazy' className='w-[50px] h-[50px] lg:w-[80px] lg:h-[80px]' />
                    </a>
                    <img src={Genie} alt="genie" loading='lazy' className='w-[80px] h-[50px] lg:w-[120px] lg:h-[80px] object-contain' />
                </div>

                {/* Center: Navigation Links - Absolutely centered */}
                <div className='absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center gap-10 text-[#2f2341] text-[16px]'>
                    {['home', 'earn', 'contact'].map((page, idx) => {
                        const path = page === 'home' ? '/genie/' : `/genie/${page}`;
                        const name = page === 'home' ? 'Home' : page === 'earn' ? 'Earn with Us' : 'Contact Us';
                        return (
                            <Link
                                key={idx}
                                to={path}
                                className={`border-b-4 transition-all duration-200 whitespace-nowrap ${
                                currPage === page ? "border-[#fb8c00] font-bold" : "border-transparent font-normal"
                                } pb-2 text-[14px]`}
                            >
                                {name}
                            </Link>
                        );
                    })}
                </div>

                {/* Right: App Store Buttons - Fixed width */}
                <div className='flex items-center gap-3 relative top-[-5px] w-[300px] justify-end'>
                    <a 
                        onClick={() => setAppStoreModal(true)}
                        className='w-[120px] h-[50px] flex items-center justify-center cursor-pointer'
                    >
                        <img 
                            src={appStore} 
                            alt="App Store" 
                            className='w-full h-full object-contain' 
                            loading="lazy" 
                        />
                    </a>
                    <a 
                        href="https://play.google.com/store/apps/details?id=com.culturtapgenie.Genie" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className='w-[120px] h-[50px] flex items-center justify-center'
                    >
                        <img 
                            src={playStore} 
                            alt="Play Store" 
                            className='w-full h-full object-contain' 
                            loading="lazy" 
                        />
                    </a>
                </div>
            </div>

            {/* Mobile Layout */}
            <div className='lg:hidden flex justify-between items-center md:px-[14px] px-4'>
                {/* Left: Logos */}
                <div className='flex items-center gap-4'>
                    <a href="/">
                        <img src={logo} alt="logo" loading='lazy' className='w-[50px] h-[50px]' />
                    </a>
                    <img src={Genie} alt="genie" loading='lazy' className='w-[80px] h-[50px] object-contain' />
                </div>

                {/* Right: Play Store and Hamburger */}
                <div className='flex items-center gap-3'>
                    <a 
                        href="https://play.google.com/store/apps/details?id=com.culturtapgenie.Genie" 
                        className='w-[120px] h-[60px] flex items-center justify-center'
                    >
                        <img 
                            src={playStore} 
                            alt="Play Store" 
                            loading='lazy' 
                            className='w-full h-full object-contain' 
                        />
                    </a>
                    <div className='cursor-pointer' onClick={handleNav}>
                        {isOpen ? <AiOutlineClose fontSize={28} /> : <GiHamburgerMenu fontSize={28} />}
                    </div>
                </div>
            </div>

            {/* Mobile Nav Drawer */}
            {isOpen && (
                <div className='w-full fixed top-[80px] left-0 lg:hidden flex justify-center z-50'>
                    <div className='flex flex-col gap-6 py-10 bg-white w-full h-screen text-[18px] items-center shadow-md'>
                        <Link to='/genie/' className={`${currPage === "home" ? "font-bold border-b-4 pb-3 border-[#fb8c00]" : ""}`} onClick={handleNav}>About Us</Link>
                        <Link to='/genie/earn' className={`${currPage === "earn" ? "font-bold border-b-4 pb-3 border-[#fb8c00]" : ""}`} onClick={handleNav}>Earn with Us</Link>
                        <Link to='/genie/contact' className={`${currPage === "contact" ? "font-bold border-b-4 pb-3 border-[#fb8c00]" : ""}`} onClick={handleNav}>Contact Us</Link>

                        {/* App Store inside mobile nav */}
                        <button onClick={() => { setAppStoreModal(!appStoreModal); }} className=''>
                            <img src={appStore} alt="appStore" loading='lazy' width="100px" height="44px" />
                        </button>
                    </div>
                </div>
            )}

            {/* App Store Modal */}
            {appStoreModal && <AppStoreModal setAppStoreModal={setAppStoreModal} />}
        </div>
    );
};

export default Navbar;